// extracted by mini-css-extract-plugin
export var banner = "_f4-0";
export var closeButton = "_f4-2";
export var greenCheckmark = "_f4-3";
export var hereLink = "_f4-4";
export var titleIcon = "_f4-1";